<template>
  <table class="table table-striped">
    <thead>
      <tr>
        <th scope="col">Id</th>
        <th scope="col">Date</th>
        <th scope="col">Type</th>
        <th scope="col">Message</th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="log in logs.slice().reverse()"
          v-bind:key="log.id"
          v-bind:class="{'table-danger' : log.type === 'Error'}">
        <th scope="row">{{ log.id }}</th>
        <td>{{ log.date | dateFormat }}</td>
        <td>{{ log.type }}</td>
        <td>{{ log.message }}</td>
      </tr>
    </tbody>
  </table>
</template>

<script>

  export class LogItem {
    constructor(id, type, message) {
      this.id = id
      this.type = type
      this.message = message
      this.date = new Date()
    }
  }

  export default {
    name: 'WsLogTable',
    filters: {
      dateFormat: function (value) {
        if (!(value instanceof Date)) return ''
        return value.toLocaleDateString(undefined, {timeStyle: 'medium', dateStyle: 'short'})
      },
    },
    props: {
      logs: {
        type: Array,
        required: true,
      }
    },
    data() {
      return {}
    }
  }
</script>
